// extracted by mini-css-extract-plugin
export default {"areas":"Template_areas__Woxo5","list":"Template_list__dwvmg","active":"Template_active__NasCe","description":"Template_description__UxOo7"};